import React, { useRef } from 'react';

export const SwipeWrapper = ({
  children,
  classStyle,
  onTap,
  isVisible = true,
}) => {
  const touchableRef = useRef();
  const onTouchMove = (e) => {
    onTap();
  };

  return (
    <>
      {isVisible && (
        <div
          ref={touchableRef}
          className={classStyle}
          onClick={onTap}
          onTouchMove={onTouchMove}
        >
          {children}
        </div>
      )}
    </>
  );
};
